import { Delete } from "@mui/icons-material";
import { Box, Checkbox, IconButton, ListItem } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { actionButton, checkbox, itemReadOnlyText, listItem } from "../../styles/shoppingListStyles";
import { renderListItemText } from "../../utils/shoppingListUtils";

const ShoppingListItemRow = ({ item, theme, onItemClick, onCheckedChange, onDeleteClick, hidePurchased }) => {
  const { t } = useTranslation();

  const handleCheckedChange = useCallback(
    (e) => {
      e.stopPropagation();
      if (onCheckedChange) {
        onCheckedChange(e.target.checked);
      }
    },
    [onCheckedChange],
  );

  const handleDeleteClick = useCallback(
    (e) => {
      e.stopPropagation();
      onDeleteClick();
    },
    [onDeleteClick],
  );

  const handleStopPropagation = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <ListItem divider sx={listItem(theme, false)} onClick={onItemClick}>
      {!hidePurchased && <Checkbox checked={Boolean(item?.purchased)} onChange={handleCheckedChange} sx={checkbox(theme)} onClick={handleStopPropagation} />}

      <Box
        sx={{
          flexGrow: 1,
          overflow: "hidden",
          mr: 1,
        }}
      >
        <Box sx={itemReadOnlyText}>{renderListItemText(item, t, item?.name)}</Box>
      </Box>

      <IconButton onClick={handleDeleteClick} sx={actionButton(theme, "error")}>
        <Delete />
      </IconButton>
    </ListItem>
  );
};

export default ShoppingListItemRow;
